import _pick from 'lodash/pick';

const FIELDS = ['id', 'shipmentId', 'shipmentDocumentTypeId', 'orgId'];

export const sanitize = values => {
  const { id: shipmentFileId, ...rest } = _pick(values, FIELDS);
  return {
    shipmentFileId,
    ...rest
  };
};
